import { FilterOption } from '../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 2,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 3,
    key: 'Erpcode',
    label: 'Codigo ERP',
    type: 'text'
  },
  {
    order: 4,
    key: 'productOriginId',
    label: 'Origen de Producto',
    type: 'precreated'
  }
]

export const defaultFilters = []
